import globalState from "./state"
import { initGalleryEventHandlers } from "./gallery";

const state = globalState.lightboxGallery;

const lightboxWrapperEl = document.querySelector(".lightbox-gallery-wrapper")
const mainImgEl = document.querySelector(".lightbox-gallery .main-image img")
const prevBtnEl = document.querySelector(".lightbox-gallery .prev")
const nextBtnEl = document.querySelector(".lightbox-gallery .next")
const thumbnailsContainerEl = document.querySelector(".lightbox-gallery .thumbnails-container")
const thumbnailsEls = thumbnailsContainerEl.querySelectorAll(".thumbnail")
const closeBtnEl = document.querySelector(".lightbox-gallery .close-btn")

function closeLightbox() {
    lightboxWrapperEl.dataset.hidden = "true";
    globalState.mainGallery.setGalleryActiveIndex(state.galleryCurrentActiveIndex);
}

lightboxWrapperEl.addEventListener("click", (e) => {
    if (e.target !== lightboxWrapperEl) return;
    closeLightbox();
})

closeBtnEl.addEventListener("click", () => {
    closeLightbox();
})

globalState.mainGallery.addGalleryIndexChangedCallback((index) => {
    state.setGalleryActiveIndex(index)
})

initGalleryEventHandlers({ galleryElements: { nextBtnEl, prevBtnEl, mainImgEl, thumbnailsEls }, state })

